/** Upcoming Renewals digest. */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { CalendarClock, ArrowLeft } from "lucide-react";

export default function RenewalsPage() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/contracts/renewals/upcoming").then(({ data }) => setRows(data.items || []));
  }, []);
  return (
    <div className="max-w-[1500px] mx-auto space-y-3" data-testid="cx-renewals-page">
      <div className="flex items-center gap-2">
        <Link to="/commercial/entitlements"
            className="text-[12px] border border-slate-200 rounded-md px-3 py-1.5 hover:bg-slate-50 inline-flex items-center gap-1">
          <ArrowLeft className="h-3.5 w-3.5" /> All contracts
        </Link>
        <div className="text-[13px] font-heading font-semibold flex items-center gap-1">
          <CalendarClock className="h-4 w-4 text-emerald-800" /> Upcoming renewals (next 90 days)
        </div>
      </div>
      <div className="border border-slate-200 rounded-lg bg-white overflow-hidden">
        <table className="min-w-full text-[11px]">
          <thead className="bg-slate-50 text-slate-500 text-[10px] uppercase">
            <tr>
              <th className="p-2 text-left">Contract</th>
              <th className="p-2 text-left">Customer</th>
              <th className="p-2 text-left">Type</th>
              <th className="p-2 text-left">Ends</th>
              <th className="p-2 text-right">Days left</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.id} className="border-t border-slate-100" data-testid={`cx-renew-${c.id}`}>
                <td className="p-2 font-semibold">
                  <Link to={`/commercial/entitlements?id=${c.id}&tab=detail`} className="hover:underline">{c.name}</Link>
                </td>
                <td className="p-2">{c.customer_name}</td>
                <td className="p-2 font-mono text-[10px]">{c.contract_type}</td>
                <td className="p-2 font-mono text-[10px]">{c.effective_until?.slice(0, 10)}</td>
                <td className={"p-2 text-right font-mono " +
                    (c.days_left < 30 ? "text-rose-700 font-semibold"
                      : c.days_left < 60 ? "text-amber-700" : "text-slate-600")}>
                  {c.days_left}d
                </td>
              </tr>
            ))}
            {!rows.length && (
              <tr><td colSpan={5} className="p-6 text-center text-slate-400">No renewals in the next 90 days.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
